import React, { useEffect, useState } from 'react';
import { Card, Toast, ToastContainer } from 'react-bootstrap';
import { Answer, Question } from './components/DataDefinitions';
import PageBreadcrumb from 'components/common/PageBreadcrumb';
import { PageBreadcrumbItem } from 'components/common/PageBreadcrumb';
import { useTranslation } from 'react-i18next';
//import qs from 'qs'; // You can install this with `npm install qs`
import apiClient, { handleAPIError } from 'helpers/apiService';
import { useAuth } from 'providers/AuthProvider'
import QuestionDetail from './components/QuestionDetail';
import { useParams } from 'react-router-dom';

const QAForumQuestionDetail: React.FC = () => {
    const { t } = useTranslation();
    const [loading, setLoading] = useState(false);
    const { question_id } = useParams();
    const auth = useAuth();

    // State to control Toast messages
    const [show, setShow] = useState(false);
    const [toastMessage, setToastMessage] = useState('');


    const [question, setQuestion] = useState<Question>();
    const [answers, setAnswers] = useState<Answer[]>();

    const breadcrumbItems: PageBreadcrumbItem[] = [
        {
            label: t('Dashboard'),
            url: '/dashboard/home'
        },
        {
            label: t('Blogs.page_title'),
            url: '/community'
        },

        {
            label: t('QAForum.page_title'),
            url: '/community/forum'
        },
        {
            label: (question ? question.title : "loading..."),
            active: true
        }
    ];


    const fetchAnswers = async () => {

        setLoading(true);
        try {
            const response = await apiClient.get(
                `/v1/forum/question/${question_id}`,
                {
                    headers: {
                        'accept': 'application/json',

                    },
                    withCredentials: true,
                }
            );

            setQuestion(response.data['question']);
            setAnswers(response.data['answers']);

        } catch (error) {
            const message = handleAPIError(error);
            if (message) {
                setToastMessage(message);
                setShow(true);
            }
        } finally {
            setLoading(false);
        }
    };

    const handleNewAnswerSubmit = async () => {
        setToastMessage("New answer added successfully");
        setShow(true);
        fetchAnswers();
    };


    useEffect(() => {
        fetchAnswers();
    }, []);

    if (loading || question == null || answers == null) {
        return <div>Loading...</div>;
    }

    return (
        <>
            <PageBreadcrumb items={breadcrumbItems} />

            <ToastContainer className="p-3" position='top-center'>
                <Toast onClose={() => setShow(false)} show={show} delay={3000} autohide>
                    <Toast.Body className=''>{toastMessage}</Toast.Body>
                </Toast>
            </ToastContainer>

            <Card className='mt-3 border border-light rounded-5' >
                <Card.Body>
                    <QuestionDetail question={question} answers={answers} onSubmit={handleNewAnswerSubmit} />
                </Card.Body>
            </Card>
        </>
    );
};


export default QAForumQuestionDetail;